import React, { ComponentProps, FC } from 'react';
import CustomDropDown from './custom-dropdown';
import DefaultDropdown from './default-dropdown';
import Select from './option-dropdown';

export interface Option {
  isSelected?: any;
  name: string;
  value: string | number;
  imageUrl?: string;
  itemCode?: any;
}

export interface DropdownProps extends Omit<ComponentProps<'select'>, 'key'> {
  error?: boolean;
  required?: boolean;
  className?: string;
  containerClassName?: string;
  labelClassName?: string;
  items?: Array<{ label: string; value: string }>;
  label?: string;
  value?: string;
  defaultValue?: any;
  customButtonElement?: JSX.Element;
  customButtonClassNames?: (open?: boolean) => string | string;
  customMenuClassNames?: (open?: boolean) => string;
  customMenuWrapperClassNames?: string;
  selectDropdownClassNames?: string;
  selectDefaultValue?: Option;
  selectOptions?: Option[];
  selectOnChange?: (option: Option) => void;
  disableFirstOption?: boolean;
  clearDropdown?: boolean;
  imageUrl?: string;
  optionsClassName?: any;
}

const Dropdown: FC<DropdownProps> = ({
  error,
  className = '',
  containerClassName = '',
  labelClassName,
  label,
  items,
  onChange,
  value,
  customButtonElement,
  customButtonClassNames,
  customMenuClassNames,
  customMenuWrapperClassNames,
  selectDropdownClassNames,
  selectDefaultValue,
  selectOptions,
  selectOnChange,
  disableFirstOption,
  clearDropdown,
  children,
  imageUrl,
  required,
  optionsClassName,
  defaultValue,
  disabled,
  ...props
}) => {
  return (
    <>
      {customButtonElement ? (
        <CustomDropDown
          buttonElement={customButtonElement}
          buttonClassNames={customButtonClassNames}
          menuClassNames={customMenuClassNames}
          menuWrapperClassNames={customMenuWrapperClassNames}
        >
          {children}
        </CustomDropDown>
      ) : selectOptions ? (
        <Select
          error={error}
          label={label}
          labelClassName={labelClassName}
          optionsClassName={optionsClassName}
          selectButtonClassName={selectDropdownClassNames}
          defaultValue={defaultValue ? defaultValue : selectOptions[0]}
          options={selectOptions}
          disableFirstOption={disableFirstOption}
          onChange={selectOnChange}
          clearDropdown={clearDropdown}
          disabled={disabled}
          required={required}
        />
      ) : (
        <DefaultDropdown
          className={className}
          containerClassName={containerClassName}
          labelClassName={labelClassName}
          label={label}
          items={items ?? []}
          // iconSrc={iconSrc}
          onChange={onChange}
          value={value}
          {...props}
        />
      )}
    </>
  );
};

export default Dropdown;
